module.exports = __webpack_public_path__ + "assets/img/shop_item.112a81a4.png";